import { Badge } from "@/components/ui/badge";
import { RedirectData } from "@utils/interface/journey.interface";
import { ColumnType } from "@utils/interface/index.interface";
import { useMemo } from "react";
import { ActionButton } from "@ui/internal/components/card";
import { useHandleAction } from "@utils/hook/index.hook";
import { endpoint } from "@services/api.services";
import { useSelectionStore } from "@utils/states/index.state";

interface ColumnListProps {
  refetch?: () => void;
}

export const ColumnList = ({ refetch }: ColumnListProps) => {
  const { handleAction } = useHandleAction({
    endpoint: endpoint.redirect,
    refetch,
  });

  const { clearSelection } = useSelectionStore();

  const columns: ColumnType<RedirectData>[] = useMemo(
    () => [
      {
        name: "Regex",
        cell: (row) => (
          <div className="font-manrope whitespace-break-spaces font-medium para-14 text-neutral-crm-900">
            <span className="block max-w-[200px] break-words !line-clamp-2">
              {row?.regex || "-"}
            </span>
          </div>
        ),
        sortable: true,
      },
      {
        name: "Source URL",
        cell: (row) => (
          <div className="font-manrope whitespace-break-spaces font-medium para-14 text-neutral-crm-900">
            <span className="block max-w-[200px] break-words !line-clamp-2">
              {row?.source || "-"}
            </span>
          </div>
        ),
        sortable: true,
      },

      {
        name: "Destination URL",
        cell: (row) => (
          <div className="font-manrope whitespace-break-spaces font-medium para-14 text-neutral-crm-900">
            <span className=" block max-w-[200px] break-words !line-clamp-2">
              {row?.destination || "-"}
            </span>
          </div>
        ),
        sortable: true,
      },
      {
        name: "Status Code",
        cell: (row) => (
          <div className="flex w-full">
            <Badge variant="outline">{row?.status_code}</Badge>
          </div>
        ),
        sortable: true,
      },
      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <button
              className="text-[#1DA077] cursor-pointer"
              onClick={() => handleAction({ type: "modal-edit", data: row.id })}
              title="Edit"
            >
              Edit
            </button>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction],
  );

  return columns;
};
